import { useState } from "react";
import { Form, Message, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import { Auth } from "../../../../api";
import { initialValues, validationSchema } from "./RegisterForm.form";
import { useLanguage } from "../../../../contexts";
import "./RegisterForm.scss";

const policyLabel = (t) => (
  <label>
    {t("privacy_policy_accepted_pre")}{" "}
    <a href="/privacy" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
      {t("privacy_policy_link")}
    </a>{" "}
    {t("privacy_policy_accepted_and")}{" "}
    <a href="/terms" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
      {t("terms_link")}
    </a>{" "}
    {t("privacy_policy_accepted_post")}
  </label>
);

const authController = new Auth();

export function RegisterForm() {
  const [error, setError] = useState("");
  const [viewMessage, setViewMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(t),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        setError("");
        await authController.register(formValue).then((result) => {
          if (result.code && result.code === 200) {
            setMessage(
              t("user_created_waiting_admin")
            );
            setViewMessage(true);
            formik.resetForm();
          }
        });
        //openLogin();
      } catch (error) {
        // console.log(error);
        setError(error.msg);
      }
    },
  });

  return (
    <div className="register-modal-form">
      {viewMessage && (
        <Message
          info
          header={t("important_information")}
          content={message}
          className="register-message"
        />
      )}

      <Form className="register-form" onSubmit={formik.handleSubmit}>
        <Form.Field error={!!formik.errors.email}>
          <label>{t("username")}</label>
          <div className="field-input-wrapper">
            <i className="user icon field-input-wrapper__icon" />
            <input
              name="email"
              type="email"
              autoComplete="username"
              placeholder={t("email")}
              onChange={formik.handleChange}
              value={formik.values.email}
            />
          </div>
          {formik.errors.email && (
            <div className="ui pointing above prompt label">{formik.errors.email}</div>
          )}
        </Form.Field>

        <Form.Field error={!!formik.errors.password}>
          <label>{t("password")}</label>
          <div className="field-input-wrapper">
            <i className="lock icon field-input-wrapper__icon" />
            <input
              name="password"
              type={passwordVisible ? "text" : "password"}
              autoComplete="new-password"
              placeholder={t("password")}
              onChange={formik.handleChange}
              value={formik.values.password}
            />
            <button
              type="button"
              className="field-input-wrapper__eye"
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              <Icon name={passwordVisible ? "eye slash" : "eye"} />
            </button>
          </div>
          {formik.errors.password && (
            <div className="ui pointing above prompt label">{formik.errors.password}</div>
          )}
        </Form.Field>

        <Form.Field error={!!formik.errors.repeatPassword}>
          <label>{t("repeat_password")}</label>
          <div className="field-input-wrapper">
            <i className="lock icon field-input-wrapper__icon" />
            <input
              name="repeatPassword"
              type={repeatPasswordVisible ? "text" : "password"}
              autoComplete="new-password"
              placeholder={t("repeat_password")}
              onChange={formik.handleChange}
              value={formik.values.repeatPassword}
            />
            <button
              type="button"
              className="field-input-wrapper__eye"
              onClick={() => setRepeatPasswordVisible(!repeatPasswordVisible)}
            >
              <Icon name={repeatPasswordVisible ? "eye slash" : "eye"} />
            </button>
          </div>
          {formik.errors.repeatPassword && (
            <div className="ui pointing above prompt label">{formik.errors.repeatPassword}</div>
          )}
        </Form.Field>

        <Form.Checkbox
          name="conditionsAccepted"
          label={policyLabel(t)}
          onChange={(_, data) =>
            formik.setFieldValue("conditionsAccepted", data.checked)
          }
          checked={formik.values.conditionsAccepted}
          error={formik.errors.conditionsAccepted}
          className="register-checkbox"
        />

        <Form.Button
          type="submit"
          primary
          fluid
          size="large"
          loading={formik.isSubmitting}
          className="register-button"
        >
          {t("create_account")}
        </Form.Button>

        {error && <p className="register-error">{error}</p>}
      </Form>
    </div>
  );
}
